/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProfileActions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import DocumentsAction from './DocumentsAction/index'
import ImagesAction from './ImagesAction/index'
import LedgerAction from './LedgerAction/index'
import MedicalHistoryAction from './MedicalHistoryAction/index'
import NotesAction from './NotesAction/index'
import ProfileAction from './ProfileAction/index'
import React from 'react'
import TreatmentAction from './TreatmentAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ProfileActions({
  children,
  viewPath = "/DesignSystem/ProfileActions",
  gap,
  marginLeft,
  type
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let gapOrdtSpaceXs = gap ?? dtSpaceXs
let gapOrdtSpaceXxs = gap ?? dtSpaceXxs
  return (<React.Fragment
>
<div
  data-testid="ProfileActions.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-2-1x2ma4': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--g-1-1x2ma4': type === 'ghost' ? typeof gapOrdtSpaceXxs === 'number' ? `${gapOrdtSpaceXxs}px` : gapOrdtSpaceXxs : typeof gapOrdtSpaceXs === 'number' ? `${gapOrdtSpaceXs}px` : gapOrdtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<ProfileAction
  viewPath={`${viewPath}/ProfileAction`}
 type={type}
/>
<MedicalHistoryAction
  viewPath={`${viewPath}/MedicalHistoryAction`}
 type={type}
/>
<TreatmentAction
  viewPath={`${viewPath}/TreatmentAction`}
 type={type}
/>
<LedgerAction
  viewPath={`${viewPath}/LedgerAction`}
 type={type}
/>
<ImagesAction
  viewPath={`${viewPath}/ImagesAction`}
 type={type}
/>
<DocumentsAction
  viewPath={`${viewPath}/DocumentsAction`}
 type={type}
/>
<NotesAction
  viewPath={`${viewPath}/NotesAction`}
 type={type}
/>
</div>
{children}
</React.Fragment>)
}